export default (props, vars) =>
  vars?.['applicationcard2']?.['item'].application_id;
